<template>
  <v-card>
      <v-card-title>
          Контрагенты
      </v-card-title>
      <v-card-text>
          <v-row>
              <v-col>
                  <v-row>
                      <v-col>
                          <v-btn  color="primary" @click="() => $router.push({name: 'JurCreatePage'})">
                              Создать
                          </v-btn>
                      </v-col>
                  </v-row>
                  <v-row>
                      <v-col>
                          <jur-table></jur-table>
                      </v-col>
                  </v-row>
              </v-col>
          </v-row>
      </v-card-text>
  </v-card>
</template>

<script>
import JurTable from "../../components/contragents/JurTable.vue";

export default {
    name: "Main",
    components: {JurTable}
}
</script>

<style scoped>

</style>